var body = $('body');

document.addEventListener('lazyloaded', function (e) {
    'use strict';
});

$(function () {
    'use strict';
    player();
    mobileMenu();
    mobileSubmenu();
    copyLink();
    handlePodcastEpisodeLinks();
    handlePodcastSubscribeList();

    const sources = [
        'iframe[src*="youtube.com"]',
        'iframe[src*="youtube-nocookie.com"]',
        'iframe[src*="player.vimeo.com"]',
        'iframe[src*="kickstarter.com"][src*="video.html"]',
        'object',
        'embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));

});
$(window).resize(function() {
    mobileSubmenu();
});

function mobileMenu(){
    $('.siskin-burger').click(function () {
        $('body').toggleClass('siskin-head-open');
    });
}

function mobileSubmenu(){
    if ($(window).width() < 930) {
        $('.siskin-nav-trigger').click(function () {
            $(this).parent().toggleClass('siskin-nav-open');
        });        
    }
}

function copyLink() {
    $(document).on('click', '.js-copy-link', function () {
        var btn = $(this);
        var text = btn.attr('data-clipboard-text');
        var iconCopy = btn.find('.siskin-share__icon-copy');
        var iconCheck = btn.find('.siskin-share__icon-check');
        var label = btn.find('.siskin-share__text');
        if (!text) return;
        function showCopied() {
            iconCopy.addClass('is-hidden');
            iconCheck.removeClass('is-hidden');
            label.text('Copied');
        }
        function resetCopy() {
            iconCopy.removeClass('is-hidden');
            iconCheck.addClass('is-hidden');
            label.text('Copy');
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(function () {
                showCopied();
                setTimeout(resetCopy, 2000);
            });
        } else {
            var input = $('<input>').val(text).css({ position: 'fixed', opacity: 0 }).appendTo(body);
            input[0].select();
            document.execCommand('copy');
            input.remove();
            showCopied();
            setTimeout(resetCopy, 2000);
        }
    });
}

function getIconSvg(iconName) {
    /* Icons match partials/icons used in subscribe-list.hbs + RSS; size 20 for episode link buttons */
    var icons = {
        'youtube': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90" width="20" height="20" role="img" aria-hidden="true"><path fill="#f00" d="M88.12 23.34c-1.04-3.87-4.09-6.92-7.96-7.96C73.14 13.5 45 13.5 45 13.5s-28.14 0-35.16 1.88c-3.87 1.04-6.92 4.09-7.96 7.96C0 30.36 0 45 0 45s0 14.64 1.88 21.66c1.04 3.87 4.09 6.92 7.96 7.96C16.86 76.5 45 76.5 45 76.5s28.14 0 35.16-1.88c3.87-1.04 6.92-4.09 7.96-7.96C90 59.64 90 45 90 45S90 30.36 88.12 23.34z"/><polygon fill="#fff" points="36,58.5 59.38,45 36,31.5"/></svg>',
        'apple': '<svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 511.86 511.86" width="20" height="20" role="img" aria-hidden="true"><defs><style>.cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}</style><linearGradient id="linear-gradient" x1="567.48" y1="-4.48" x2="563.14" y2="513.88" gradientTransform="matrix(1, 0, 0, -1, -309.35, 513.86)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#822cbe"/><stop offset="1" stop-color="#d772fb"/></linearGradient></defs><rect class="cls-1" width="511.86" height="511.86" rx="113.87"/><path class="cls-2" d="M240.44,448.26c-15.27-5.46-18.54-12.88-24.81-56.38-7.28-50.55-8.87-81.84-4.65-91.75,5.59-13.14,20.78-20.6,42-20.68,21.07-.09,36.39,7.44,42,20.68,4.24,9.89,2.65,41.2-4.64,91.75-4.95,35.32-7.67,44.25-14.5,50.25-9.38,8.31-22.69,10.61-35.32,6.14Zm-65.22-51.87c-52.73-25.94-86.51-69.82-98.79-128.2-3.07-15.07-3.59-51-.69-64.84,7.68-37.11,22.36-66.13,46.75-91.79,35.15-37.06,80.37-56.65,130.7-56.65,49.82,0,94.86,19.23,129.16,55.18,26.1,27.13,40.77,55.84,48.28,93.67,2.56,12.59,2.56,46.92.17,61.08a181.4,181.4,0,0,1-69.1,113c-13,9.79-44.7,26.89-49.82,26.89-1.88,0-2.05-1.94-1.19-9.81,1.53-12.63,3.07-15.25,10.23-18.26,11.44-4.77,30.89-18.63,42.83-30.61a163,163,0,0,0,42.82-75.41c4.44-17.57,3.93-56.64-1-74.73C390,138.36,343.1,93.66,285.61,81.72c-16.73-3.42-47.1-3.42-64,0-58.18,11.94-106.29,58.86-121,117.89-3.92,16-3.92,55.11,0,71.15,9.73,39.07,35,74.9,68.08,96.23a147.45,147.45,0,0,0,17.58,10.07c7.16,3.07,8.7,5.63,10.06,18.25.85,7.68.68,9.9-1.19,9.9-1.2,0-9.9-3.75-19.11-8.19ZM175.9,327c-17.75-14.16-33.44-39.28-39.93-63.91-3.92-14.88-3.92-43.17.17-58,10.75-40.06,40.27-71.12,81.22-85.71,14-4.94,45-6,62.27-2.25C339,130.33,381.15,189.79,373,248.77c-3.24,23.77-11.43,43.29-25.93,61.42-7.17,9.16-24.57,24.54-27.64,24.54-.51,0-1-5.8-1-12.87V309l8.88-10.58c33.44-40.06,31.05-96-5.46-132.74-14.16-14.29-30.54-22.69-51.7-26.56-13.65-2.53-16.55-2.53-30.88-.17-21.76,3.55-38.61,12-53.58,26.78C148.94,202,146.55,258.29,180,298.38L188.8,309v13c0,7.17-.57,13-1.27,13s-5.63-3.41-10.92-7.68Zm59.2-69.66c-15.18-7.07-23.37-20.39-23.54-37.76,0-15.61,8.7-29.23,23.71-37.2,9.56-5,26.45-5,36,0a46.34,46.34,0,0,1,22.18,26.85c9.9,33.65-25.76,63.13-58,48.07Z" transform="translate(-0.14 -0.14)"/><circle class="cls-2" cx="255.74" cy="221.24" r="42.55"/><path class="cls-2" d="M260,280.42a83.61,83.61,0,0,1,14.25,2.9,51.55,51.55,0,0,1,14.26,7.13c3.76,2.73,6.49,5.56,8.19,9s2.56,7.54,3.07,14.25c.34,6.72.34,16-1.19,33.44s-4.61,42.79-7,59.08-4.09,23.55-6.31,28.84a25.82,25.82,0,0,1-18.94,16.55,41,41,0,0,1-9.89.85,42.41,42.41,0,0,1-9.9-.85c-3.92-.86-9-2.39-12.8-5.46-3.92-3.07-6.48-7.51-8.53-13.31s-3.58-12.8-5.63-26.79-4.78-34.8-6.48-50.67-2.39-26.79-2.53-34.13.17-11,1-14.5a28.93,28.93,0,0,1,4.09-9.38,31.14,31.14,0,0,1,6.83-7,27.87,27.87,0,0,1,8-4.3A60.8,60.8,0,0,1,241.35,283c4.43-.85,9.55-1.7,12.18-2.05a13.34,13.34,0,0,1,5.56,0Z" transform="translate(-0.14 -0.14)"/></svg>',
        'spotify': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1333.33 1333.3" width="20" height="20" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" role="img" aria-hidden="true"><path d="M666.66 0C298.48 0 0 298.47 0 666.65c0 368.19 298.48 666.65 666.66 666.65 368.22 0 666.67-298.45 666.67-666.65C1333.33 298.49 1034.88.03 666.65.03l.01-.04zm305.73 961.51c-11.94 19.58-37.57 25.8-57.16 13.77-156.52-95.61-353.57-117.26-585.63-64.24-22.36 5.09-44.65-8.92-49.75-31.29-5.12-22.37 8.84-44.66 31.26-49.75 253.95-58.02 471.78-33.04 647.51 74.35 19.59 12.02 25.8 37.57 13.77 57.16zm81.6-181.52c-15.05 24.45-47.05 32.17-71.49 17.13-179.2-110.15-452.35-142.05-664.31-77.7-27.49 8.3-56.52-7.19-64.86-34.63-8.28-27.49 7.22-56.46 34.66-64.82 242.11-73.46 543.1-37.88 748.89 88.58 24.44 15.05 32.16 47.05 17.12 71.46V780zm7.01-189.02c-214.87-127.62-569.36-139.35-774.5-77.09-32.94 9.99-67.78-8.6-77.76-41.55-9.98-32.96 8.6-67.77 41.56-77.78 235.49-71.49 626.96-57.68 874.34 89.18 29.69 17.59 39.41 55.85 21.81 85.44-17.52 29.63-55.89 39.4-85.42 21.8h-.03z" fill="#1ed760" fill-rule="nonzero"/></svg>',
        'overcast': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 365 365" width="20" height="20" role="img" aria-hidden="true"><path fill="#f57e20" d="M182.5 16.64C90.9 16.64 16.64 90.9 16.64 182.5c0 73.27 47.51 135.43 113.4 157.39l42.46-127.79c-12.36-4.13-21.3-15.82-21.3-29.6 0-17.24 14.02-31.26 31.26-31.26s31.26 14.02 31.26 31.26c0 13.78-8.94 25.47-21.3 29.6l42.46 127.79c65.89-21.96 113.4-84.12 113.4-157.39C348.36 90.9 274.1 16.64 182.5 16.64z"/><path fill="#fff" d="M172.63 212.1c-12.39-4.13-21.33-15.82-21.33-29.6 0-17.24 14.02-31.26 31.26-31.26 17.24 0 31.26 14.02 31.26 31.26 0 13.78-8.94 25.47-21.33 29.6l42.47 127.79c32.5-10.84 56.87-36.33 67.13-68.27H262.2c-9.9 33.65-40.58 58.11-76.57 58.11-36 0-66.67-24.46-76.57-58.11H105.5c10.26 31.94 34.63 57.43 67.13 68.27l42.46-127.79z"/></svg>',
        'rss': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="20" height="20" fill="currentColor" role="img" aria-hidden="true"><path d="M8.6 46.746a8.627 8.627 0 1 0 8.6 8.627 8.678 8.678 0 0 0-8.6-8.627zM.7 21.567H.2V33.5h.5a29.836 29.836 0 0 1 29.8 29.8v.7h11.9v-.7A41.719 41.719 0 0 0 .7 21.567z"/><path d="M.7 0H.2v11.937h.5A51.4 51.4 0 0 1 52 63.3v.7h12v-.7A63.369 63.369 0 0 0 .7 0z"/></svg>',
        'link': '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" aria-hidden="true"><path d="M9 15l6 -6"/><path d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464"/><path d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463"/></svg>'
    };
    return icons[iconName] || icons['link'];
}

function handlePodcastEpisodeLinks() {
    var scriptTag = document.getElementById('podcast-episode');
    var container = document.getElementById('podcast-episode-links');
    var wrap = document.getElementById('siskin-episode-links-wrap');
    if (!scriptTag || !container) {
        if (wrap) wrap.style.display = 'none';
        return;
    }
    try {
        var data = JSON.parse(scriptTag.textContent);
        var iconMap = {
            'YouTube': 'youtube',
            'Apple': 'apple',
            'Apple Podcasts': 'apple',
            'Apple podcasts': 'apple',
            'Spotify': 'spotify',
            'Overcast': 'overcast',
            'RSS': 'rss'
        };
        Object.keys(data).forEach(function (platform) {
            var url = data[platform];
            if (!url) return;
            var iconName = iconMap[platform] || 'link';
            var link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.className = 'siskin-episode-links__link' + (platform === 'RSS' ? ' siskin-episode-links__link--rss' : '');
            link.setAttribute('aria-label', 'Listen on ' + platform);
            link.innerHTML = getIconSvg(iconName) + '<span>' + platform + '</span>';
            container.appendChild(link);
        });
    } catch (e) {
        if (typeof console !== 'undefined' && console.warn) {
            console.warn('Error parsing podcast episode links:', e);
        }
    }
    if (wrap && !container.children.length) {
        wrap.style.display = 'none';
    }
}

function handlePodcastSubscribeList() {
    var scriptTag = document.getElementById('podcast-subscribe-urls');
    var items = document.querySelectorAll('.siskin-subscribe-list__item');
    if (!scriptTag || !items.length) return;
    try {
        var data = JSON.parse(scriptTag.textContent);
        items.forEach(function (li) {
            var platform = li.getAttribute('data-platform');
            var url = data[platform];
            var link = li.querySelector('.siskin-subscribe-list__link');
            if (!link) return;
            if (url) {
                link.setAttribute('href', url);
                li.classList.remove('is-hidden');
            } else {
                link.setAttribute('href', '#');
                li.classList.add('is-hidden');
            }
        });
    } catch (e) {
        if (typeof console !== 'undefined' && console.warn) {
            console.warn('Error parsing podcast subscribe URLs:', e);
        }
    }
}

function player() {
    'use strict';
    var player = $('.player');
    var playerAudio = $('.player-audio');
    var playerMedia = player.find('.post-media');
    var playerThumbnail = player.find('.post-image');
    var playerTitle = player.find('.post-title-link');   
    
    var playerProgress = $('.player-progress');
    var playerSpeed = 1;
    var buttonEpisode;
    var buttonPlay = $('.player-button-play');
    var buttonBackward = $('.player-button-backward');
    var buttonForward = $('.player-button-forward');
    var buttonSpeed = $('.player-button-speed');
    var buttonClose = $('.player-button-close');
    var timeCurrent = $('.player-time-current');
    var timeDuration = $('.player-time-duration');
    var buttonDownload = $('.btn-download');
    var buttonTweet = $('.btn-tw');
    var buttonFb = $('.btn-fb');

    $('.viewport').on('click', '.js-play', function () {
        var clicked = $(this);
        var url = clicked.attr('data-url');
        var id = clicked.attr('data-id');

        // When clicking the player bar's play button, use current source (don't clear src)
        if (!url && clicked.closest('.player').length) {
            url = playerMedia.attr('data-url') || (playerAudio[0].currentSrc && playerAudio[0].currentSrc.length ? playerAudio[0].currentSrc : '');
            id = playerMedia.attr('data-id') || id;
        }
        if (!url || url === '#') {
            return;
        }

        if ($('.player-external').length) {
            body.addClass('player-opened');
        }

        if (id !== playerMedia.attr('data-id')) {
            playerAudio.attr('src', url);

            var thumbSrc = clicked.find('.post-image').attr('src');
            if (thumbSrc) {
                playerThumbnail.attr('srcset', thumbSrc);
            }
            // On single post, .post is the whole article (main + related); scope to header or card only
            var titleScope = clicked.closest('.article-header').length
                ? clicked.closest('.article-header')
                : clicked.closest('.post');
            var titleEl = titleScope.find('.post-card-title').first();
            var titleText = titleEl.length ? titleEl.text() : '';
            if (titleText) {
                playerTitle.text(titleText);
            }
            buttonDownload.attr('href', url);
            var postLink = titleEl.find('a').attr('href') || titleScope.find('.post-card-title a').attr('href');
            if (!postLink && clicked.closest('.article-header').length) {
                postLink = window.location.pathname;
            }
            if (postLink) {
                buttonFb.attr('href', 'https://www.facebook.com/sharer.php?u=' + site_url + postLink);
                buttonTweet.attr('href', 'https://twitter.com/intent/tweet?url=' + site_url + postLink);
            }

            var prevId = playerMedia.attr('data-id');
            if (prevId) {
                $('.post-' + prevId).find('.icon').removeClass('icon-pause').addClass('icon-play');
            }

            playerMedia.attr('data-id', id);
            playerMedia.attr('data-url', url);
            buttonPlay.attr('data-id', id);
            buttonEpisode = $('[data-id="' + id + '"]').find('.icon-play');
        }

        if (playerAudio[0].paused) {
            var playPromise = playerAudio[0].play();
            if (playPromise !== undefined) {
                playPromise
                    .then(function () {
                        // Make clicked button pause
                        clicked.find('.icon').removeClass('icon-play').addClass('icon-pause');
                        // Make playing episode button pause
                        if (buttonEpisode) {
                            buttonEpisode.addClass('icon-pause');
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        } else {
            playerAudio[0].pause();
            // Make clicked button play
            clicked.find('.icon').removeClass('icon-pause').addClass('icon-play');
            // Make paused episode button play
            if (buttonEpisode) {
                buttonEpisode.removeClass('icon-pause').addClass('icon-play');
            }
        }
    });

    playerAudio.on('loadedmetadata', function () {
       
        timeDuration.text(
            new Date(playerAudio[0].duration * 1000).toISOString().substr(11, 8)
        );
        playerAudio[0].addEventListener('timeupdate', function (e) {
            timeCurrent.text(
                new Date(e.target.currentTime * 1000)
                    .toISOString()
                    .substr(11, 8)
            );
            playerProgress.css(
                'width',
                (e.target.currentTime / playerAudio[0].duration) * 100 + '%'
            );
        });
    });

    buttonBackward.on('click', function () {
        playerAudio[0].currentTime = playerAudio[0].currentTime - 10;
    });

    buttonForward.on('click', function () {
        playerAudio[0].currentTime = playerAudio[0].currentTime + 30;
    });

    buttonSpeed.on('click', function () {
        if (playerSpeed < 2) {
            playerSpeed += 0.5;
        } else {
            playerSpeed = 1;
        }

        playerAudio[0].playbackRate = playerSpeed;
        buttonSpeed.text(playerSpeed + 'x');
    });
}